import userScenario from './user';
import { MarketingEmailStatuses } from 'core/utils/marketing-email';

export default function (server) {
  userScenario(server, {
    marketingEmailStatus: MarketingEmailStatuses.MANDATORY,
  });
}
